

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export const AccessDeniedCard: React.FC = () => {
  return (
    <div className="container max-w-4xl py-10">
      <Card>
        <CardHeader>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You don't have permission to access the feedback administration panel.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p>Please contact an administrator if you believe you should have access.</p>
        </CardContent>
      </Card>
    </div>
  );
};
